import AddressCreateView from './AddressFormView';

export default AddressCreateView;
